module.exports = __webpack_public_path__ + "static/hero-mobile1-8ea15a28837efeffa9848c270854363f.png";